import { Component, Input } from '@angular/core';

@Component({
  selector: 'activity-row-chat',
  template: `
  <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
    <mat-icon>chat</mat-icon>
  </div>
  <div class="description">
    <div class="text">
      <span>
        <strong>{{ activity.subType.charAt(0).toUpperCase() + activity.subType.slice(1) }} Chat Message</strong>
        {{ activity.subType === 'outgoing' ? 'to ' : 'from ' }}
        <span *ngIf="borrower.primary_contact && borrower.primary_contact.first">
          {{ borrower.primary_contact.first }} {{ borrower.primary_contact.last }}
        </span>
        "{{ activity.meta['content'] | slice:0:49 }}..."
      </span>
    </div>

    <span class="info">
      <span class="options">
        <a
          ng-if="borrower.status !== 'doNotContact'"
          [routerLink]="['/borrower/' + activity.borrowerId]"
          [queryParams]="{pane: 'messages', subpane: 'chat'}">
          View
        </a>
      </span>
    </span>
  </div>
  `,
  styles: [],
  standalone: false
})
export class ActivityRowChatComponent {
  @Input() activity;
  @Input() borrower;
}
